<template>

  <section id="checkout-sponsorship"
           v-bind:class="checkoutVisble ? 'uk-margin-large-top uk-margin-medium-bottom uk-padding-large uk-padding-remove-horizontal': ''"
  >
    <div class="uk-container uk-container-large"
         v-if="checkoutVisble"
    >
      <div class="uk-align-center uk-width-1-1 uk-width-2-3@m">
        <h2 class="uk-h2">Klangpatenschaft abschlie&szlig;en</h2>
        <form class="uk-grid-small"
              v-on:submit.prevent="placeOrder"
              data-uk-grid
        >
          <div class="uk-width-1-2@m">
            <input class="uk-input" type="text" placeholder="Name, Vorname des Paten"
                   data-vv-as="Ihr voller Name" name="sponsorFullName"
                   v-validate="{ required: true, min: 5 }"
                   v-model="sponsorFullname"
            >
            <span v-show="errors.has('sponsorFullName')" class="uk-form-danger uk-text-small">{{ errors.first('sponsorFullName') }}<br></span>
          </div>
          <div class="uk-width-1-2@m">
            <label><input class="uk-checkbox" type="checkbox"
                          v-model="giftSponsorship"
            > Klangpatenschaft verschenken</label>
          </div>
          <transition v-on:enter="enter"
                      v-on:leave="leave"
          >
            <div class="uk-width-1-1" v-if="giftSponsorship">
              <input class="uk-input uk-width-1-2@m input-single-width" type="text" placeholder="Name, Vorname des Beschenkten"
                     name="giftedToName"
                     v-model="giftedToName"
              >
            </div>
          </transition>
          <div class="uk-width-1-2@m">
            <input class="uk-input" type="text" placeholder="Straße und Hausnummer"
                   data-vv-as="Die Straße" name="street"
                   v-validate="{ required: true, min: 5 }"
                   v-model="street"
            >
            <span v-show="errors.has('street')" class="uk-form-danger uk-text-small">{{ errors.first('street') }}<br></span>
          </div>
          <div class="uk-width-1-2@m">
            <div data-uk-grid>
              <div class="uk-width-1-3">
                <input class="uk-input" type="text" placeholder="PLZ"
                       data-vv-as="Die PLZ" name="postalCode" maxlength="5"
                       v-validate="{ required: true, digits: 5 }"
                       v-model="postalCode"
                >
              </div>
              <div class="uk-width-expand">
                <input class="uk-input" type="text" placeholder="Ort"
                       data-vv-as="Der Ort" name="city"
                       v-validate="{ required: true, min: 2 }"
                       v-model="city"
                >
              </div>
              <div class="uk-width-1-1 uk-margin-small-top">
                <span v-show="errors.has('postalCode')" class="uk-form-danger uk-text-small">{{ errors.first('postalCode') }}<br></span>
                <span v-show="errors.has('city')" class="uk-form-danger uk-text-small">{{ errors.first('city') }}</span>
              </div>
            </div>
          </div>
          <div class="uk-width-1-2@m">
            <input class="uk-input" type="text" placeholder="E-Mail-Adresse"
                   data-vv-as="Die E-Mail-Adresse" name="email"
                   v-validate="{ required: true, email: true}"
                   v-model="email"
            >
            <span v-show="errors.has('email')" class="uk-form-danger uk-text-small">{{ errors.first('email') }}</span>
          </div>
          <div class="uk-width-1-2@m">
            <label><input class="uk-checkbox" type="checkbox" v-model="allowPublication"> Ich bin mit der Veröffentlichung meines Namens in gedruckter Form und online als Klangpatin/&shy;Klangpate einverstanden.</label>
          </div>
          <div class="uk-width-1-1">
            <input class="uk-button uk-button-default uk-button-large uk-text-large uk-align-center uk-margin-medium-top"
                   type="submit" name="place-order" value="Bestellung abschicken"
            >
          </div>
        </form>

      </div>
    </div>
    <modal name="checkout-done" width="60%" :height="'auto'">
      <div class="uk-panel">
        <div class="uk-position-top-right uk-margin-small-top uk-margin-small-right uk-position-z-index">
          <a href="#" class="uk-icon-link" data-uk-icon="icon: close; ratio:2;" v-on:click.prevent="hideModal"></a>
        </div>
        <div class="uk-panel uk-padding-large">
          <h3>Ihre Bestellung wurde aufgenommen!</h3>
          <p>Wir haben die von Ihnen gewählten Orgelpfeifen für Sie reserviert.</p>
          <p>In einer E-Mail haben wir für Sie die Bestellung zusammen gefasst. Bitte sehen Sie in Ihrem Postfach nach.</p>
          <p>Sobald wir den Geldeingang feststellen können, erhalten Sie postalisch Ihre Patenschafts-Urkunde.</p>
          <button class="uk-button uk-button-default uk-align-right uk-margin-small-top uk-margin-small-bottom"
                  v-on:click.prevent="hideModal"
          >OK</button>
        </div>
      </div>
    </modal>

  </section>

</template>

<script>
import {mapGetters} from 'vuex'
import _ from 'lodash'
import { CREATE_SPONSOR_MUTATION, CREATE_SPONSORSHIP_ORDER, FIND_SPONSOR, PIPE_ADD_SPONSOR } from '../../constants/graphql'
import EventBus from '../../event-bus'
import {Power2, TweenMax} from 'gsap'
import service from '../../service/service'
const moment = require('moment')

export default {
  name: 'checkout-sponsorship',
  data () {
    return {
      sponsorFullname: undefined,
      giftSponsorship: false,
      giftedToName: '',
      street: undefined,
      postalCode: undefined,
      city: undefined,
      email: undefined,
      allowPublication: false,
      sponsorNotCreated: true,
      sponsor: {},
      sponsor_selector: 'name=',
      sponsorId: undefined,
      checkoutVisble: false
    }
  },
  apollo: {
    sponsor: {
      query: FIND_SPONSOR,
      variables () {
        return {
          selector: this.sponsor_selector
        }
      },
      skip () {
        return this.sponsorNotCreated
      },
      result ({ data, loader, networkStatus }) {
        if (data.sponsor.list.length !== 0) {
          this.sponsorId = data.sponsor.list[0].id
        }
      }
    }
  },
  computed: {
    ...mapGetters(['sponsorship', 'chosenPipes'])
  },
  methods: {
    beforeEnter: function (el) {
      TweenMax.fromTo(el, 0.75, {y: '20px', autoAlpha: 0}, {y: 1, autoAlpha: 1, ease: Power2.easeInOut})
    },
    enter: function (el, done) {
      TweenMax.fromTo(el, 0.75, { y: '60px' }, {y: 0, autoAlpha: 1, ease: Power2.easeInOut})
      done()
    },
    leave: function (el, done) {
      TweenMax.fromTo(el, 0.5, {x: 0, autoAlpha: 1}, {
        x: '-100px',
        autoAlpha: 0,
        ease: Power2.easeInOut,
        onComplete: () => {
          done()
        }})
    },
    showModal () {
      this.$modal.show('checkout-done')
    },
    hideModal () {
      this.$modal.hide('checkout-done')
    },
    updateSponsor () {
      this.$store.dispatch('updateSponsorship', {
        action: 'updateSponsor',
        pipe: undefined,
        sponsor: {
          id: this.sponsorId,
          fullname: this.sponsorFullname,
          giftedToName: this.giftedToName,
          allowPublication: this.allowPublication,
          street: this.street,
          postalCode: this.postalCode,
          city: this.city
        },
        grandTotal: undefined
      })
    },
    placeOrder () {
      // Formular Validieren
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.updateSponsor()
          let sponsorName = _.kebabCase(this.email)
          // neuen Paten anlegen
          this.$apollo.mutate({
            mutation: CREATE_SPONSOR_MUTATION,
            variables: {
              parent: '2461',
              name: sponsorName,
              title: this.sponsorFullname,
              email_unique: this.email,
              allow_publication: this.allowPublication,
              street: this.street,
              postal_code: this.postalCode,
              city: this.city
            }
          }).then((data) => {
            // Pate bisher nicht vorhanden, setze erhaltene Id aus Mutation in
            // data und lasse den watcher übernehmen
            let sponsor = _.flatMapDeep(data)
            this.sponsorId = sponsor[0].createSponsor.id
          }).catch((error) => {
            // wenn der Pate schon zuvor eine Patenschaft abgeschlossen hat,
            // hole seine Id
            if (error.graphQLErrors.length !== 0) {
              console.log(error.graphQLErrors[0].message)
              let sponsorExists = error.graphQLErrors[0].message === '`name` is already taken.'
              if (sponsorExists) {
                this.sponsor_selector = 'name=' + sponsorName
                this.sponsorNotCreated = false
                this.$apollo.queries.sponsor.refetch()
              }
            }
          })
        }
      })
    },
    createSponsorshipOrder () {
      let orderName = moment().format('YYYY-MM-DD-HH-mm-ss') + '-sponsor-' + this.sponsorId
      // console.log(orderName)
      // lege neue Bestellung für den Paten an
      this.$apollo.mutate({
        mutation: CREATE_SPONSORSHIP_ORDER,
        variables: {
          parent: this.sponsorId,
          name: orderName,
          title: orderName,
          sponsor_ref: [this.sponsorId],
          pipes_ref: this.chosenPipes,
          name_text: this.giftedToName
        }
      }).then((data) => {
        let order = _.flatMapDeep(data)
        let orderId = order[0].createSponsorship_order.id
        if (orderId) {
          // Bestellung erfolgreich, Pfeifen reservieren
          _.each(this.chosenPipes, (pipeId) => {
            // console.info('Füge Pate zu Pfeife ' + pipeId + ' hinzu')
            this.reservePipe(pipeId)
          })
          // E-Mail versenden
          this.sendEmail()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    reservePipe (pipeId) {
      // Reservierung der Pfeifen der Bestellung
      this.$apollo.mutate({
        mutation: PIPE_ADD_SPONSOR,
        variables: {
          id: pipeId,
          sponsor_ref: [this.sponsorId]
        }
      }).then((data) => {
        // console.info(data)
        let pipe = _.flatMapDeep(data)
        let pipeId = pipe[0].updatePipe.id
        if (pipeId) {
          // Pfeife wurde aktualisiert
          // console.info('die Pfeife ' + pipeId + ' hat nun den Sponsor ' + this.sponsorId)
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    refreshPipesEvent () {
      EventBus.$emit('REFRESH_PIPES', 'refresh from Checkout')
    },
    resetChosenPipesEvent () {
      EventBus.$emit('RESET_CHOSEN_PIPES', this.sponsorship.pipes)
    },
    sendEmail () {
      let to = this.email
      let from = 'bestellung@martinsorgel.de'
      let subject = 'Ihre neue Klangpatenschaft | Pfarrkirche St. Martin'
      let emailData = this.sponsorship

      service.sendEmail(to, from, subject, emailData)
        .then((response) => {
          // Bestätigung anzeigen
          this.showModal()

          // Formular und Pfeifen zurücksetzen, Daten aktualisieren
          this.sponsorId = undefined
          this.sponsorFullname = undefined
          this.giftSponsorship = false
          this.giftedToName = ''
          this.street = undefined
          this.postalCode = undefined
          this.city = undefined
          this.email = undefined
          this.allowPublication = false
          this.sponsorNotCreated = true
          this.sponsor = {}
          this.sponsor_selector = 'name='
          this.sponsorId = undefined
          this.updateSponsor()
          this.checkoutVisble = false
          this.resetChosenPipesEvent()
          this.refreshPipesEvent()
        })
        .catch((response) => {
          // Mail konnte nicht gesendet werden
        })
    }
  },
  watch: {
    sponsorId (newId, oldId) {
      this.sponsorId = newId
      if (typeof newId !== 'undefined') {
        this.createSponsorshipOrder()
      }
    }
  },
  created () {
    this.$validator.localize('de')
  },
  mounted () {
    EventBus.$on('SHOW_CHECKOUT', (payload) => {
      this.checkoutVisble = payload
    })
  }
}
</script>

<style lang="scss">
  @import "~uikit/src/scss/variables-theme";

  #checkout-sponsorship {
    form {
     .input-single-width {
       @media (min-width: $breakpoint-medium) {
        width: 49.3%;
       }
     }
    }
  }

  .fade-bottom-enter-active, .fade-bottom-leave-active {
    transition: opacity .75s, transform .75s;
  }
  .fade-bottom-enter, .fade-bottom-leave-to {
    opacity: 0;
    transform: translateY(3em);
  }
</style>



// WEBPACK FOOTER //
// src/components/ConfiguratorPage/CheckoutSponsorship.vue